// extracted by mini-css-extract-plugin
module.exports = {"outer":"AnimatedText_outer__3N3v6","inner":"AnimatedText_inner__3tN8i","visible":"AnimatedText_visible__1QfE8","fw":"AnimatedText_fw__KU124"};